import {useContext} from 'react';
import {PostContext} from '~/ViewInvitation/components/Guestlist/context/PostContext';

export const usePostContext = () => {
  const context = useContext(PostContext);

  if (!context) {
    throw new Error('usePostContext must be used within a PostContextProvider');
  }

  return context;
};
